var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rupee-1-frame-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6994 4.45082H13.7892L14.9165 2.5H4.04388L2.91653 4.45082H7.09268C8.01364 4.72844 8.76223 5.2859 9.17612 5.99348H4.04388L2.9165 7.9443H9.43077C9.04442 9.27651 7.55034 10.2694 5.76481 10.2694H3.53791V12.0276L9.85699 17.5H12.6084V16.8197L6.83408 11.9317C9.25725 11.8335 11.2368 10.1382 11.5993 7.94427H13.7892L14.9165 5.99345H11.4867C11.3255 5.43051 11.0554 4.90984 10.6994 4.45082Z",
    fill: "#666666"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.00e09cb74dff49e62f33eb5bd4aa2efd.svg";
export { ForwardRef as ReactComponent };